import React from "react";
import {AlertBox} from "./styles";

export const ErrorsAlertBox = (props) => {
	const error = props.errors
		? props.error
		: props.children;

	if (!props.show) {
		return <></>;
	}

	return (
		<AlertBox severity="error" className="registration-error-box">
			{error}
		</AlertBox>
	);
};